import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';

export default styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  td: {
    fontFamily: '"signikalight",Arial,sans-serif'
  }
}));
